export const requestTypes = {
  SELL: "sell",
  ORDER: "order",
  STOCK: "stock",
  PX_ORDER: "px-order",
  PX_CART: "px-cart",
};

export const journeyConst = {
  components: {
    SEARCH: "search",
    ASSIGN_CLIENT: "assign_client",
    CONFIRM_REQUEST: "confirm_request",
    SEND_QUOTE: "send_quote",
    VERIFY_SERIAL: "verify_serial",
    CONSIGNMENT_AGREEMENT: "consignment_agreement",
    PURCHASING_AGREEMENT: "purchasing_agreement",
    PURCHASE_ORDER: "purchase_order",
    PUBLISH_LISTING: "publish_listing",
    PAYMENTS: "PAYMENTS",
    UPLOAD_INVOICE: "upload_invoice",
    ASSIGN_LISTING: "assign_listing",
    ASSIGN_REQUEST: "assign_request",
    SUMMARY: "summary",
    SUBMITTING: "submitting",
    SUCCESS: "success",
  },
  actions: {
    ADD: "add",
    FINISH: "finish",
    // ADD_MAIN — rep clicked "Add another product" on CONFIRM REQUEST.
    // Inserts a fresh SEARCH + CONFIRM REQUEST pair for the next
    // additional main slot in the same request group, capped at 3.
    ADD_MAIN: "add_main",
  },
};

export const journeyLabels = {
  search: "Search Product",
  searchCart: "Cart Item",
  selectToSell: "Select Product To Sell",
  sendQuote: "Select Quote",
  assignClient: "Assign Client",
  verifySerial: "Verify Serial",
  consignmentAgreement: "Consignment Agreement",
  purchasingAgreement: "Purchasing Agreement",
  purchaseOrder: "Purchase Order",
  uploadInvoice: "Upload Invoice",
  assignListing: "Assign Listing",
  payments: "payments",
  confirmRequest: "Confirm Request",
  assignRequest: "Assign Request",
  publishListing: "Publish Listing",
  summary: "Summary",
};

export const quoteActionOptions = [
  // { id: "SP", name: "STRAIGHT PURCHASE ONLY" },
  // { id: "CONSIGN", name: "CONSIGNMENT ONLY" },
  { id: "SP_CONSIGN", name: "STRAIGHT PURCHASE & CONSIGNMENT" },
];
